/**
 * What the customer is told about LX-04 (REFIT-S, DESIGN ED-170): the robustness note and the before/after overview carry this
 * sentence. LX-04 feeds the short-text index, so a rewrite that addresses it can change the flagged status of a text under
 * 1,000 words; the three checks that guard every rewrite apply to it unchanged.
 */
export const LX04_INDEX_NOTE =
	'Lexical variation (LX-04) feeds the index of texts under 1,000 words, so a rewrite that lowers it can change whether such a text is flagged. The checks that guard every rewrite (no new pattern in the passage or beside it, the meaning check) apply unchanged, and a synonym collapse that changes the content fails the meaning check.';
